// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"SupplierSearch_Tooltip__3gpCe"};